import { API, tokenRefreshTime } from '../../shared/constants/constants';
import store from '../../store';
import { setAccessToken, setIdToken } from './userSlice';

let refreshTokenTimeoutId = null;
let refreshTimerEnabled = false;

function scheduleNextRefresh() {
  if (typeof window === 'undefined' || !refreshTimerEnabled) {
    return;
  }

  if (refreshTokenTimeoutId !== null) {
    window.clearTimeout(refreshTokenTimeoutId);
  }

  refreshTokenTimeoutId = window.setTimeout(refreshTokenHandler, tokenRefreshTime);
}

export function refreshToken() {
  return new Promise((resolve, reject) => {
    API.post('/user/refresh')
      .then((response) => {
        const tokens = JSON.parse(response.data.tokens) || null;

        if (tokens?.access_token && tokens?.id_token) {
          store.dispatch(setIdToken(tokens.id_token));
          store.dispatch(setAccessToken(tokens.access_token));

          resolve({ success: true, tokens });
        } else {
          store.dispatch(setAccessToken(''));
          store.dispatch(setIdToken(''));

          resolve({ success: false });
        }
      })
      .catch((err) => {
        console.error('Authorization error. Please try again.');

        store.dispatch(setAccessToken(''));
        store.dispatch(setIdToken(''));

        resolve({ success: false });
      });
  });
}

export function stopRefreshTokenTimer() {
  refreshTimerEnabled = false;

  if (refreshTokenTimeoutId !== null && typeof window !== 'undefined') {
    window.clearTimeout(refreshTokenTimeoutId);
    refreshTokenTimeoutId = null;
  }
}

export function startRefreshTokenTimer() {
  if (typeof window === 'undefined') {
    return;
  }

  refreshTimerEnabled = true;
  scheduleNextRefresh();
}

export async function refreshTokenHandler() {
  if (!refreshTimerEnabled) {
    return;
  }

  const revalidated = await refreshToken();

  if (!refreshTimerEnabled) {
    return;
  }

  if (revalidated?.success) {
    // Call the function every 45 minutes to get a new token
    scheduleNextRefresh();
  } else {
    stopRefreshTokenTimer();
    window.location.replace(process.env.REACT_APP_COGNITO_URL);
  }
}
